.container {
  min-height: calc(var(--mirai-ui-space-L) * 4.75);
  padding: var(--mirai-ui-space-M);
}

.checkout {
  min-height: calc(var(--mirai-ui-space-XXL) * 7.5);
  width: 100%;
}

.checkout :global(.sfc-main-container .sfc-cfa-button) {
  background-color: var(--mirai-ui-button-background);
  border: solid var(--mirai-ui-border-width) var(--mirai-ui-button-background);
  border-radius: var(--mirai-ui-button-radius);
  color: var(--mirai-ui-button-color);
}

.checkout :global(.sfc-main-container .sfc-cfa-button:hover),
.checkout :global(.sfc-main-container .sfc-cfa-button:active) {
  background-color: var(--mirai-ui-button-background-active);
  border-color: var(--mirai-ui-button-background-active);
  color: var(--mirai-ui-button-color-active);
}
